import { createContext } from "react";
import { UserData } from "@models/UserData";

type SecurityContextData = {
  isAuthenticated: boolean;
  user: undefined | UserData;
};

export default createContext<SecurityContextData>({
  isAuthenticated: false,
  user: undefined,
});
